module.exports = __webpack_public_path__ + "img/living_room_thumb.7b75616b.jpg";